import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Suppress harmless browser extension errors
window.addEventListener('error', (event) => {
  // Suppress the common browser extension message channel error
  if (
    event.message &&
    event.message.includes('message channel closed') &&
    event.message.includes('asynchronous response')
  ) {
    event.preventDefault();
    return true;
  }
});

// Suppress unhandled promise rejections from browser extensions
window.addEventListener('unhandledrejection', (event) => {
  if (
    event.reason &&
    typeof event.reason === 'object' &&
    event.reason.message &&
    event.reason.message.includes('message channel closed') &&
    event.reason.message.includes('asynchronous response')
  ) {
    event.preventDefault();
    return true;
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
